"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyColorGroup = void 0;

var _jsxRuntime = require("react/jsx-runtime");

var classes = {
  "root": "sty-color-group-module__root___nf6Ih",
  "title": "sty-color-group-module__title___1El9-",
  "grid": "sty-color-group-module__grid___2Q4AC"
};

var StyColorGroup = function StyColorGroup(_ref) {
  var children = _ref.children,
      title = _ref.title,
      _ref$cellWidth = _ref.cellWidth,
      cellWidth = _ref$cellWidth === void 0 ? '1fr' : _ref$cellWidth,
      _ref$cols = _ref.cols,
      cols = _ref$cols === void 0 ? 3 : _ref$cols;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: classes.root,
    style: {
      // @ts-ignore
      '--color-group-cell-width': cellWidth,
      '--color-group-cells': cols
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: classes.title,
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: classes.grid,
      children: children
    })]
  });
};

exports.StyColorGroup = StyColorGroup;